import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

// Libs
import { fetchMerchantInfo } from '@/api/fetchMerchantInfo'
import { fetchUserProfile } from '@/api/fetchUserProfile'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { ROLE_TYPE } from '@/constants/roleType'

interface Props {
  memberInfoId?: string
}

export const useShop = ({ memberInfoId }: Props) => {
  const router = useRouter()
  const { query } = router
  const memberId = memberInfoId || query?.id

  const { data: userProfile } = useQuery(
    [QUERY_KEY.FETCH_USER_PROFILE, { queryId: query.id }],
    () => fetchUserProfile({ memberId: memberId as string }),
    {
      enabled: !!memberId && router.isReady,
    },
  )

  const { data: merchantInfo } = useQuery(
    [QUERY_KEY.FETCH_MERCHANT_INFO, { memberInfoId: memberId, queryId: query.id }],
    () => fetchMerchantInfo({ merchantId: userProfile?.roleDetail[ROLE_TYPE.MERCHANT]?.id }),
    {
      enabled: !!userProfile?.roleDetail[ROLE_TYPE.MERCHANT]?.id && router.isReady,
    },
  )

  return {
    merchantId: userProfile?.roleDetail[ROLE_TYPE.MERCHANT]?.id,
    name: userProfile?.nickName,
    headshotUrl: userProfile?.headshotUrl ? userProfile?.headshotUrl : '',
    intro: userProfile?.intro,
    profileName: userProfile?.profileName,
    roles: userProfile?.roles,
    refCode: userProfile?.refCode,
    totalProduct: merchantInfo?.totalProduct,
  }
}
